"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.playViaIframe = exports.searchMusic = exports.doAlert = exports.doConfirm = exports.pointerEvent = void 0;
var widget_1 = require("../util/widget");
var soundcloud_service_1 = require("./soundcloud-service");
var isMobile = require('is-mobile');
var soundCloudService = new soundcloud_service_1.SoundCloudService({ clientId: '8m4K5d2x4mNmUHLhLmsGq9vxE3dDkxCm' });
exports.pointerEvent = isMobile() ? 'touchstart' : 'click';
function doConfirm(template) {
    var frame = document.querySelector('#modal-confirm');
    var activeClass = 'modal-prompt--active';
    var cusRes;
    var prm = new Promise(function (res) {
        cusRes = res;
    });
    var confirm = false;
    var cb = function (e) {
        e.preventDefault();
        switch (e.target.closest('[action]').getAttribute('action')) {
            case 'yes':
                confirm = true;
                frame.classList.remove(activeClass);
                break;
            case 'no':
                confirm = false;
                frame.classList.remove(activeClass);
                break;
            case 'close':
                frame.classList.remove(activeClass);
                break;
        }
        e.currentTarget.removeEventListener(exports.pointerEvent, cb);
        cusRes(confirm);
    };
    frame.querySelector('p').innerHTML = template;
    //show frame;
    frame.classList.add(activeClass);
    frame.addEventListener(exports.pointerEvent, cb);
    return prm;
}
exports.doConfirm = doConfirm;
function doAlert(template) {
    var frame = document.querySelector('#modal-alert');
    var activeClass = 'modal-prompt--active';
    var cb = function (e) {
        e.preventDefault();
        var action = e.target.closest('[action]').getAttribute('action');
        if (action === 'close') {
            e.currentTarget.removeEventListener(exports.pointerEvent, cb);
            frame.classList.remove(activeClass);
        }
    };
    frame.querySelector('p').innerHTML = template;
    //show frame;
    frame.classList.add(activeClass);
    frame.addEventListener(exports.pointerEvent, cb);
}
exports.doAlert = doAlert;
function renderSearchView(frame, keywordInput) {
    return __awaiter(this, void 0, void 0, function () {
        var container, keyword, searchResult, embedableTracks, htmlBundle;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!soundCloudService)
                        return [2 /*return*/];
                    container = frame.querySelector('#search-music-result');
                    keyword = keywordInput.value;
                    if (!keyword)
                        return [2 /*return*/];
                    container.innerHTML = "\n        <li class=\"modal-music-search__li modal-music-search__li--loading\">\n           <img src=\"./assets/images/ripple.svg\">\n        </li>\n        ";
                    return [4 /*yield*/, soundCloudService.search({
                            q: keyword,
                            limit: 100
                        }).then(function (searchResult) {
                            widget_1.widget.trigger('search', [searchResult]);
                            return searchResult;
                        })];
                case 1:
                    searchResult = _a.sent();
                    embedableTracks = searchResult === null || searchResult === void 0 ? void 0 : searchResult.collection.filter(function (o) {
                        return o.embeddable_by === 'all' && !!o.title;
                    });
                    htmlBundle = embedableTracks.map(function (o, index) {
                        var _a, _b;
                        return "\n            <li class=\"modal-music-search__li music-search-item\" style=\"animation-delay:".concat(100 * index, "ms\">\n                <div class=\"music-search-item__inner\">\n                    <div class=\"music-search-item__head\">\n                        <div class=\"music-search-item__img\">\n                            <img src=\"").concat(o.artwork_url, "\" onerror=\"this.parentNode.classList.add('music-search-item__img--not-found')\" >\n                        </div>\n                    </div>\n                    <div class=\"music-search-item__body\">\n                        <div class=\"music-search-item__title\">\n                            <span>").concat(o.title, "</span>\n                        </div>\n                        <div class=\"music-search-item__descrp\">\n                            <div class=\"music-search-item__artist\">\n                            ").concat(((_a = o.publisher_metadata) === null || _a === void 0 ? void 0 : _a.artist) || 'Unknown', "\n                            </div>\n                            <div class=\"music-search-item__album-title\">").concat(((_b = o.publisher_metadata) === null || _b === void 0 ? void 0 : _b.album_title) || '', "</div>\n                        </div>\n                    </div>\n                    <button class=\"music-search-item__play\" action=\"choose\" data-id=\"").concat(o.id, "\">\n                    </button>\n                </div>\n            </li>\n            ");
                    }).join('');
                    container.scrollTop = 0;
                    container.innerHTML = htmlBundle;
                    return [2 /*return*/];
            }
        });
    });
}
function searchMusic() {
    var _this = this;
    var frame = document.querySelector('#modal-music-search');
    var activeClass = 'modal-music-search--active';
    var keywordInput = frame.querySelector('#music-search-input');
    var cusRes;
    var chosenId;
    var prm = new Promise(function (res, rej) {
        cusRes = res;
    });
    var keydownCallback = function (evt) {
        if (evt.keyCode == 13) {
            if (keywordInput.value && document.activeElement === keywordInput) {
                renderSearchView(frame, keywordInput);
            }
        }
    };
    var cb = function (e) { return __awaiter(_this, void 0, void 0, function () {
        var actionTarget, action;
        return __generator(this, function (_a) {
            actionTarget = e.target.closest('[action]') || e.target;
            action = actionTarget.getAttribute('action');
            if (action === 'close') {
                e.currentTarget.removeEventListener(exports.pointerEvent, cb);
                document.removeEventListener('keydown', keydownCallback);
                frame.classList.remove(activeClass);
                cusRes(false);
            }
            else if (action === 'search') {
                renderSearchView(frame, keywordInput);
            }
            else if (action === 'choose') {
                chosenId = actionTarget.getAttribute('data-id') || '';
                e.currentTarget.removeEventListener(exports.pointerEvent, cb);
                document.removeEventListener('keydown', keydownCallback);
                frame.classList.remove(activeClass);
                cusRes(chosenId);
            }
            return [2 /*return*/];
        });
    }); };
    frame.classList.add(activeClass);
    frame.addEventListener(exports.pointerEvent, cb);
    document.addEventListener('keydown', keydownCallback);
    return prm;
}
exports.searchMusic = searchMusic;
function playViaIframe(trackId) {
    var source = "https%3A//api.soundcloud.com/tracks/".concat(trackId);
    return widget_1.widget.load(source).then(function () {
        widget_1.widget.play();
    });
}
exports.playViaIframe = playViaIframe;
